export default __webpack_public_path__ + "static/media/mts-bank.8a00daee.png";